import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import NoTicketsForEvent from './components/react-no-tickets-for-event';

import './NoListingsEventView.scss';

class NoListingsEventView extends Component {
  render() {
    const {eventId, webURI} = this.props;

    return (
      <div className="NoListingsEventView">
        <NoTicketsForEvent eventId={eventId} webURI={webURI} />
      </div>
    );
  }
}

NoListingsEventView.propTypes = {
  /**
   * Redirect URI
   */
  webURI: PropTypes.string,

  /**
   * Id of event
   */
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default NoListingsEventView;
